// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Settings_context} from '../settings_ctx';
import {Install_btn} from '../ui/install_btn';
import cn from 'classnames';
import styles from './vpn_products_hero.module.less';

const No_card_icon = ()=>{
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
      xmlns="http://www.w3.org/2000/svg">
        <path d="M7 9.9992C7.35873 9.99941 7.64929 10.2908 7.64941
          10.6496C7.6492 11.0083 7.35868 11.2988 7 11.299H4C3.64115 11.299
          3.34982 11.0084 3.34961 10.6496C3.34974 10.2907 3.64109 9.9992 4
          9.9992H7Z" fill="#7D7D7D"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.57715
          0.506036C1.84959 0.272512 2.25949 0.304111 2.49316 0.576348L14.4932
          14.5763C14.7268 14.8489 14.6953 15.2587 14.4229 15.4924C14.1503
          15.7259 13.7405 15.6945 13.5068 15.4221L12.2871 13.9992H3C1.89543
          13.9992 1 13.1038 1 11.9992V3.9992C1.00009 3.19451 1.47595 2.50201
          2.16113 2.18475L1.50684 1.42205C1.2735 1.14954 1.30481 0.739603
          1.57715 0.506036ZM2.2998 8.299V11.9992C2.2998 12.3858 2.6134 12.6994
          3 12.6994H11.1729L7.40137 8.299H2.2998ZM2.2998
          5.9992V6.9992H6.28711L5.42969 5.9992H2.2998ZM3 3.299C2.61348 3.299
          2.29993 3.61271 2.2998 3.9992V4.6994H4.31641L3.11523 3.299H3Z"
          fill="#7D7D7D"/>
        <path d="M13 1.9992C14.1045 1.9992 14.9999 2.89474 15
          3.9992V11.8497C15 12.2086 14.7091 12.4995 14.3502 12.4996C13.9912
          12.4996 13.7002 12.2087 13.7002 11.8497V8.299H11.1498C10.7909
          8.299 10.5 8.00808 10.5 7.6492C10.5 7.29035 10.7909 6.99943 11.1498
          6.9994L13.7002 6.9992V5.9992H9.1499C8.79097 5.9992 8.5 5.70823 8.5
          5.3493C8.5 4.99037 8.79097 4.6994
          9.1499 4.6994H13.7002V3.9992C13.7001 3.61271 13.3865 3.299 13
          3.299H6.6499C6.29097 3.299 6 3.00803 6 2.6491C6 2.29017 6.29097
          1.9992 6.6499 1.9992H13Z" fill="#7D7D7D"/>
      </svg>;
};

interface i_vpn_products_hero_props {
    header?: string;
    description?: string;
    cta?: string;
}

export const Vpn_products_hero = (props: i_vpn_products_hero_props)=>{
    const {header = 'Hola VPN Products',
        description = `Choose the Hola VPN that fits your device — easy setup
        and global access.`, cta = 'Try Hola VPN Free'} = props;
    const {theme} = useContext(Settings_context);
    const install_btn_cls = cn(['hola_btn hola_btn--round hola_btn--lg',
        'hola_btn--txt_colored hola_btn--no_jump hola_btn-no_arrow',
        styles.button]);
    return <div className={styles.vpn_products_hero}>
      <div className={styles.banner}>
        <h1 className={cn([styles.header, theme.text_center])}>{header}</h1>
        <p className={cn([theme.u3, styles.description])}>{description}</p>
        <Install_btn keep_btn_text text={cta}
          no_redirect className={install_btn_cls}/>
        <div className={styles.no_card}>
          <No_card_icon />
          <p className={theme.p3}>No credit card required</p>
        </div>
      </div>

      <div className={styles.rating}>
        <div className={cn([styles.rating_card, styles.rating_card_one])}>
          <h4 className={styles.rating_card_header}>4.9 stars</h4>
          <p className={cn([theme.p2, theme.color_n700, theme.text_center,
            theme.med])}>in Chrome Web Store</p>
        </div>
        <div className={cn([styles.rating_card, styles.rating_card_two])}>
          <h4 className={styles.rating_card_header}>263 million</h4>
          <p className={cn([theme.p2, theme.color_n700, theme.text_center,
            theme.med])}>downloads and counting</p>
        </div>
        <div className={cn([styles.rating_card, styles.rating_card_three])}>
          <h4 className={styles.rating_card_header}>16 years</h4>
          <p className={cn([theme.p2, theme.color_n700, theme.text_center,
            theme.med])}>In business</p>
        </div>
        <div className={cn([styles.rating_card, styles.rating_card_four])}>
          <h4 className={styles.rating_card_header}>195 countries</h4>
          <p className={cn([theme.p2, theme.color_n700, theme.text_center,
            theme.med])}>to browse from</p>
        </div>
      </div>
    </div>;
};

interface i_vpn_products_hero_editor_props {
    value: i_vpn_products_hero_props;
    on_change: (new_val: i_vpn_products_hero_props)=>void;
}

export const Vpn_products_hero_editor = (
props: i_vpn_products_hero_editor_props)=>{
    const {value, on_change} = props;
    return <Editor value={value} on_change={on_change} editors={[
      {label: 'Header', type: 'text', key: 'header'},
      {label: 'Description', type: 'text', key: 'description'},
      {label: 'CTA', type: 'text', key: 'cta'},
    ]}/>;
};
